export default __webpack_public_path__ + "static/media/avatar23.ae5a34cb.png";